// ---------------------------------------------------------------
// Icons.js — Iconos de línea del portal (SVG inline, sin librerías)
// ---------------------------------------------------------------
const base = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.8,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  viewBox: "0 0 24 24",
  "aria-hidden": true,
};

export const IconDashboard = () => (
  <svg {...base}>
    <rect x="3" y="3" width="7" height="7" rx="1.5" />
    <rect x="14" y="3" width="7" height="7" rx="1.5" />
    <rect x="3" y="14" width="7" height="7" rx="1.5" />
    <rect x="14" y="14" width="7" height="7" rx="1.5" />
  </svg>
);

export const IconCalendar = () => (
  <svg {...base}>
    <rect x="3" y="4.5" width="18" height="16" rx="2.5" />
    <path d="M3 9.5h18M8 2.5v4M16 2.5v4" />
  </svg>
);

export const IconSchedule = () => (
  <svg {...base}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l3.2 1.8" />
  </svg>
);

export const IconTimer = () => (
  <svg {...base}>
    <circle cx="12" cy="13.5" r="7.5" />
    <path d="M12 10v3.5l2.5 1.5M9.5 2.5h5M12 2.5V6" />
  </svg>
);

export const IconUsers = () => (
  <svg {...base}>
    <circle cx="9" cy="8" r="3.4" />
    <path d="M2.8 20c.7-3.3 3.2-5 6.2-5s5.5 1.7 6.2 5" />
    <path d="M16 5.6a3.2 3.2 0 0 1 0 5.8M18.5 15.4c1.7.7 2.7 2.2 3 4.6" />
  </svg>
);

export const IconImport = () => (
  <svg {...base}>
    <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" />
    <path d="M14 3v5h5M12 11v6M9.5 14.5 12 17l2.5-2.5" />
  </svg>
);

export const IconConfig = () => (
  <svg {...base}>
    <path d="M4 8h10M18 8h2M4 16h2M10 16h10" />
    <circle cx="16" cy="8" r="2.2" />
    <circle cx="8" cy="16" r="2.2" />
  </svg>
);

export const IconSearch = () => (
  <svg {...base}>
    <circle cx="11" cy="11" r="6.5" />
    <path d="m20 20-3.8-3.8" />
  </svg>
);

export const IconTasks = () => (
  <svg {...base}>
    <rect x="3.5" y="3.5" width="17" height="17" rx="4" />
    <path d="m8 12.2 2.6 2.6 5.4-5.6" />
  </svg>
);

export const IconGuide = () => (
  <svg {...base}>
    <circle cx="12" cy="12" r="9" />
    <circle cx="12" cy="12" r="3.8" />
    <path d="m9.3 9.3-3.6-3.6M14.7 9.3l3.6-3.6M14.7 14.7l3.6 3.6M9.3 14.7l-3.6 3.6" />
  </svg>
);

export const IconProfile = () => (
  <svg {...base}>
    <circle cx="12" cy="12" r="9" />
    <circle cx="12" cy="10" r="3.2" />
    <path d="M6.3 18.4c1-2.6 3.1-3.9 5.7-3.9s4.7 1.3 5.7 3.9" />
  </svg>
);

export const IconLogout = () => (
  <svg {...base}>
    <path d="M14 4h4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-4" />
    <path d="M10 8 6 12l4 4M6 12h11" />
  </svg>
);
